// extracted by mini-css-extract-plugin
export default {"mainCard":"SupportCard_mainCard__6iSxI","textSupport":"SupportCard_textSupport__0A1-B","iconCall":"SupportCard_iconCall__RY7sC","iconMessage":"SupportCard_iconMessage__lP1mw"};